<script lang="ts">
  import { wallet } from "../lib/wallet.svelte";
  import Icon from "./Icon.svelte";
</script>

<header class="header">
  <div class="header-content">
    <a href="/" class="logo">
      <div class="logo-mark">
        <Icon name="terminal" size={16} />
      </div>
      <span class="logo-text">Terminal</span>
    </a>

    <nav class="nav">
      {#if wallet.connected}
        <button class="wallet-button connected" onclick={() => wallet.disconnect()}>
          <div class="wallet-avatar">
            <Icon name="user" size={14} />
          </div>
          <span class="wallet-address">{wallet.shortAddress}</span>
          <Icon name="chevron-down" size={14} />
        </button>
      {:else}
        <button
          class="connect-button"
          onclick={() => wallet.connect()}
          disabled={wallet.loading}
        >
          {#if wallet.loading}
            <Icon name="loader" size={16} class="spinning" />
            <span>Connecting...</span>
          {:else}
            <Icon name="wallet" size={16} />
            <span>Connect</span>
          {/if}
        </button>
      {/if}
    </nav>
  </div>
</header>

<style>
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: rgba(10, 10, 10, 0.8);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--border-subtle);
    z-index: 1000;
  }

  .header-content {
    max-width: 1200px;
    margin: 0 auto;
    height: 100%;
    padding: 0 var(--space-6);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .logo {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    color: var(--text-primary);
    text-decoration: none;
  }

  .logo-mark {
    width: 28px;
    height: 28px;
    background: var(--text-primary);
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--bg-primary);
  }

  .logo-text {
    font-weight: 600;
    font-size: 0.9375rem;
    letter-spacing: -0.01em;
  }

  .nav {
    display: flex;
    align-items: center;
    gap: var(--space-3);
  }

  .connect-button {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    padding: var(--space-2) var(--space-4);
    background: var(--accent-primary);
    color: white;
    border-radius: var(--radius-md);
    font-size: 0.875rem;
    font-weight: 500;
    transition: all var(--transition-fast);
  }

  .connect-button:hover:not(:disabled) {
    background: #2563eb;
    transform: translateY(-1px);
  }

  .connect-button:disabled {
    opacity: 0.7;
  }

  .wallet-button {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    padding: var(--space-2) var(--space-3);
    background: var(--bg-tertiary);
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-md);
    font-size: 0.875rem;
    color: var(--text-primary);
    transition: all var(--transition-fast);
  }

  .wallet-button:hover {
    background: var(--bg-hover);
    border-color: var(--border-default);
  }

  .wallet-avatar {
    width: 24px;
    height: 24px;
    background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
    border-radius: var(--radius-full);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .wallet-address {
    font-family: var(--font-mono);
    font-size: 0.8125rem;
  }

  :global(.spinning) {
    animation: spin 1s linear infinite;
  }
</style>
